import panels from './panels';
import products from './products';

export default {
  translation: {
    panels,
    products,
  },
};
